import widget from './widget.vue';
import map from './map.vue';
// import bar from './bar'
export default widget;
export { map, };
